import React, { useEffect, useState } from "react";
import { TrendUp, TrendDown } from "@phosphor-icons/react";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";

const money = (n) => (n > 0 ? "+" : n < 0 ? "−" : "") + "$" + Math.abs(Number(n || 0)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const wl = (w, l) => `${w || 0}-${l || 0}`;

export default function PicksWeekly() {
  const { user } = useAuth();
  const [data, setData] = useState(null);
  const isAdmin = !!(user && user.role === "admin");

  useEffect(() => {
    (async () => {
      const { data } = await api.get("/picks/feed");
      setData(data);
    })();
  }, []);

  return (
    <div className="max-w-[1300px] mx-auto px-6 py-10">
      <div className="mb-8">
        <div className="text-[11px] uppercase tracking-[0.3em] text-[#007AFF] mb-1">Weekly Performance</div>
        <h1 className="font-display text-5xl sm:text-6xl leading-none">WEEKLY SUMMARY</h1>
        <p className="text-sm text-zinc-400 mt-3">Mon–Sun sessions. {isAdmin ? "Stakes reset every Monday." : "Volume + W/L by analyst each week."}</p>
      </div>
      {!data ? (
        <div className="text-zinc-500 font-mono-d" data-testid="weekly-loading">Loading weekly summary…</div>
      ) : (
        <div className="bg-[#121212] border border-white/10 rounded-sm overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead className="text-[10px] uppercase tracking-[0.15em] text-zinc-500 border-b border-white/10">
                <tr>
                  <th className="text-left px-4 py-3">Week of</th>
                  <th className="text-right px-3 py-3">Charlie · Bets</th>
                  <th className="text-right px-3 py-3">Charlie · W-L</th>
                  {isAdmin && <th className="text-right px-3 py-3">Charlie · P/L</th>}
                  <th className="text-right px-3 py-3">Dakota · Bets</th>
                  <th className="text-right px-3 py-3">Dakota · W-L</th>
                  {isAdmin && <th className="text-right px-3 py-3">Dakota · P/L</th>}
                  <th className="text-right px-3 py-3">Combined Bets</th>
                  <th className="text-right px-3 py-3">Combined W-L</th>
                  {isAdmin && <th className="text-right px-4 py-3">Combined P/L</th>}
                  {isAdmin && <th className="text-left px-4 py-3">Status</th>}
                </tr>
              </thead>
              <tbody>
                {data.weekly_summary.map((w, i) => (
                  <tr key={i} className="border-b border-white/5" data-testid="weekly-row">
                    <td className="px-4 py-2 font-mono-d text-zinc-300">{w.week_start}</td>
                    <td className="px-3 py-2 text-right font-mono-d text-zinc-400">{w.charlie_bets}</td>
                    <td className="px-3 py-2 text-right font-mono-d text-zinc-300">{wl(w.charlie_wins, w.charlie_losses)}</td>
                    {isAdmin && (
                      <td className={`px-3 py-2 text-right font-mono-d ${w.charlie_pnl > 0 ? "text-[#22C55E]" : w.charlie_pnl < 0 ? "text-[#FF3B30]" : "text-zinc-400"}`}>
                        {money(w.charlie_pnl)}
                      </td>
                    )}
                    <td className="px-3 py-2 text-right font-mono-d text-zinc-400">{w.dakota_bets}</td>
                    <td className="px-3 py-2 text-right font-mono-d text-zinc-300">{wl(w.dakota_wins, w.dakota_losses)}</td>
                    {isAdmin && (
                      <td className={`px-3 py-2 text-right font-mono-d ${w.dakota_pnl > 0 ? "text-[#22C55E]" : w.dakota_pnl < 0 ? "text-[#FF3B30]" : "text-zinc-400"}`}>
                        {money(w.dakota_pnl)}
                      </td>
                    )}
                    <td className="px-3 py-2 text-right font-mono-d text-zinc-300">{w.combined_bets}</td>
                    <td className="px-3 py-2 text-right font-mono-d font-bold text-white">{wl(w.combined_wins, w.combined_losses)}</td>
                    {isAdmin && (
                      <td className={`px-4 py-2 text-right font-mono-d font-bold ${w.combined_pnl > 0 ? "text-[#22C55E]" : w.combined_pnl < 0 ? "text-[#FF3B30]" : "text-zinc-400"}`}>
                        {money(w.combined_pnl)}
                      </td>
                    )}
                    {isAdmin && (
                      <td className="px-4 py-2 text-[10px] uppercase tracking-wider">
                        {w.combined_pnl <= -750 ? <span className="text-[#FF3B30] flex items-center gap-1"><TrendDown size={12} /> Stop-loss</span>
                         : w.combined_pnl >= 1500 ? <span className="text-[#22C55E] flex items-center gap-1"><TrendUp size={12} /> Take-profit</span>
                         : <span className="text-zinc-500">Active</span>}
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}
